import { has } from 'lodash'

import type { AppointmentRequestBody } from './client'
import type { Appointment } from '~/terminierungsportal/types/appointmentTypes'
import {
  AppointmentUpdateAction
} from '~/terminierungsportal/types/appointmentTypes'

export const makeUpdatePayload = (
  partialAppointment: Partial<Appointment>
): AppointmentRequestBody => {
  const payload: AppointmentRequestBody = {
    action: AppointmentUpdateAction.Update
  }

  const { additionalInfos, alternativeContact, contactInfo, optIns } =
    partialAppointment

  if (additionalInfos) {
    payload.additionalInfos = additionalInfos
  }

  if (alternativeContact) {
    payload.alternativeContact = alternativeContact
  }

  if (contactInfo) {
    const { email, phone } = contactInfo
    payload.contactInfo = { email, phone }
  }

  if (optIns) {
    payload.optIns = optIns
  }

  if (has(partialAppointment, 'preferredTimeslot')) {
    payload.preferredTimeslot = partialAppointment.preferredTimeslot
  }

  return payload
}
